/* Calzado Audor · «Llega gratis el jueves» — la fecha de entrega
   SOP: architecture/SOP-entrega.md · D-072

   TRES PARTES EN UN ARCHIVO. (1) El núcleo: funciones puras que, con un instante y las reglas,
   dicen qué fecha y qué cuenta; es lo ÚNICO que calcula fechas, y la ficha y el cajón le
   preguntan a la misma función. (2) El montaje: arma la pieza una vez y después solo cambia
   lo que cambió. (3) El elemento <aud-entrega> de la ficha, que lee las reglas de la sección
   «Fecha de entrega» (#aud-entrega-datos) y se pinta cada segundo. El cajón no usa el
   elemento: `aud-carrito.js` llama al montaje sobre su propio <aud-cj-entrega>.

   DOS FORMAS, UN NÚCLEO (D-078). En el cajón, la TARJETA: pastilla con la cuenta, frase y
   fecha. En la ficha, RENGLONES SUELTOS: la fecha con su ícono y debajo la frase con la cuenta,
   sin tarjeta y sin nada que se mueva, para no quitarle atención a la oferta ni al botón.

   LA HORA ES LA DE BOGOTÁ, NO LA DEL TELÉFONO. Colombia no cambia de horario: UTC−5 todo el
   año. Cada fecha se guarda como si UTC fuera la hora de pared de Bogotá, así que
   `getUTCHours()` da la hora de allá sea cual sea el huso del equipo.

   El banco: execution/banco-entrega/banco.js (fechas) y banco-forma.mjs (forma). */
(function (raiz) {
  'use strict';
  if (raiz.AudEntrega) return;

  var DIA = 864e5;
  var DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
  var MESES = ['ene.', 'feb.', 'mar.', 'abr.', 'may.', 'jun.', 'jul.', 'ago.', 'sep.', 'oct.', 'nov.', 'dic.'];

  /* Las reglas por omisión son las que dio Jonathan el 2026-09-29. En el tema las escribe la
     sección «Fecha de entrega»; aquí quedan por si el JS corre solo (el banco). */
  var REGLAS = {
    zonas: {
      pais: { corte: [null, '14:00', '14:00', '14:00', '14:00', '14:00', '12:00'], entrega: [1, 3], entregaSabado: false },
      bogota: { corte: [null, '12:00', '12:00', '12:00', '12:00', '12:00', '12:00'], entrega: [0, 0], entregaSabado: true }
    },
    sinDespacho: []
  };

  /* ---------- la hora de Bogotá ---------- */
  function enBogota(instante) {
    return new Date((instante instanceof Date ? instante.getTime() : Number(instante)) - 5 * 3600e3);
  }
  function clave(d) { return d.toISOString().slice(0, 10); }
  function inicio(d) { var x = new Date(d.getTime()); x.setUTCHours(0, 0, 0, 0); return x; }
  function mas(d, n) { return new Date(d.getTime() + n * DIA); }
  function aLas(d, hhmm) {
    var p = String(hhmm).split(':'), x = inicio(d);
    x.setUTCHours(Number(p[0]) || 0, Number(p[1]) || 0, 0, 0);
    return x;
  }
  function dias(a, b) { return Math.round((inicio(b) - inicio(a)) / DIA); }

  /* ---------- los festivos de Colombia, CALCULADOS ----------
     Una lista escrita a mano se vence el 1 de enero. Ley 51 de 1983 (Emiliani): doce festivos
     se corren al lunes siguiente; seis se quedan en su fecha; cinco cuelgan de la Pascua. */
  function pascua(a) {
    var g = a % 19, c = Math.floor(a / 100), k = Math.floor(a / 4);
    var h = (c - Math.floor(c / 4) - Math.floor((8 * c + 13) / 25) + 19 * g + 15) % 30;
    var i = h - Math.floor(h / 28) * (1 - Math.floor(29 / (h + 1)) * Math.floor((21 - g) / 11));
    var j = (a + k + i + 2 - c + Math.floor(c / 4)) % 7;
    var p = i - j, mes = 3 + Math.floor((p + 40) / 44), dia = p + 28 - 31 * Math.floor(mes / 4);
    return new Date(Date.UTC(a, mes - 1, dia));
  }
  function alLunes(d) { var w = d.getUTCDay(); return w === 1 ? d : mas(d, (8 - w) % 7); }
  var memo = {};
  function festivosDe(a) {
    if (memo[a]) return memo[a];
    var f = {}, p = pascua(a);
    function fijo(m, d, nombre) { f[clave(new Date(Date.UTC(a, m - 1, d)))] = nombre; }
    function lunes(m, d, nombre) { f[clave(alLunes(new Date(Date.UTC(a, m - 1, d))))] = nombre; }
    fijo(1, 1, 'Año Nuevo'); fijo(5, 1, 'Día del Trabajo'); fijo(7, 20, 'Independencia');
    fijo(8, 7, 'Batalla de Boyacá'); fijo(12, 8, 'Inmaculada Concepción'); fijo(12, 25, 'Navidad');
    lunes(1, 6, 'Reyes'); lunes(3, 19, 'San José'); lunes(6, 29, 'San Pedro y San Pablo');
    lunes(8, 15, 'Asunción'); lunes(10, 12, 'Día de la Raza'); lunes(11, 1, 'Todos los Santos');
    lunes(11, 11, 'Independencia de Cartagena');
    f[clave(mas(p, -3))] = 'Jueves Santo'; f[clave(mas(p, -2))] = 'Viernes Santo';
    f[clave(alLunes(mas(p, 39)))] = 'Ascensión';
    f[clave(alLunes(mas(p, 60)))] = 'Corpus Christi';
    f[clave(alLunes(mas(p, 68)))] = 'Sagrado Corazón';
    memo[a] = f;
    return f;
  }
  function festivo(d) { return !!festivosDe(d.getUTCFullYear())[clave(d)]; }

  /* ---------- el despacho y la entrega ---------- */
  function cerrado(d, reglas) {
    return festivo(d) || (reglas.sinDespacho || []).indexOf(clave(d)) >= 0;
  }
  function corteDe(d, zona, reglas) {
    var c = zona.corte[d.getUTCDay()];
    return !c || cerrado(d, reglas) ? null : aLas(d, c);
  }
  function diaDeEntrega(d, zona, reglas) {
    var w = d.getUTCDay();
    if (w === 0 || cerrado(d, reglas)) return false;
    return w === 6 ? !!zona.entregaSabado : true;
  }
  function sumar(d, n, zona, reglas) {
    var x = d, k = 0;
    while (k < n) { x = mas(x, 1); if (diaDeEntrega(x, zona, reglas)) k += 1; }
    while (!diaDeEntrega(x, zona, reglas)) x = mas(x, 1);
    return x;
  }

  function calcular(instante, zonaId, reglas) {
    reglas = reglas || REGLAS;
    var zona = (reglas.zonas && reglas.zonas[zonaId]) || REGLAS.zonas.pais;
    var ahora = enBogota(instante), hoy = inicio(ahora);
    var corte = corteDe(hoy, zona, reglas), sale = null, saleHoy = false;

    if (corte && ahora < corte) { sale = hoy; saleHoy = true; }
    for (var i = 1; !sale && i < 30; i += 1) {
      if (corteDe(mas(hoy, i), zona, reglas)) sale = mas(hoy, i);
    }
    if (!sale) sale = mas(hoy, 1); /* un mes sin despacho no es un dato: que no reviente */

    return {
      zona: zonaId, ahora: ahora, sale: sale, saleHoy: saleHoy, corte: saleHoy ? corte : null,
      resta: saleHoy ? Math.floor((corte - ahora) / 1000) : 0,
      desde: sumar(sale, zona.entrega[0], zona, reglas),
      hasta: sumar(sale, zona.entrega[1], zona, reglas)
    };
  }

  /* ---------- decirlo ---------- */
  /* «2:00 p. m.» · «12 del mediodía». «12:00 p. m.» se presta a duda; «del mediodía», no. */
  function hora(d) {
    var h = d.getUTCHours(), m = d.getUTCMinutes();
    if (h === 12 && m === 0) return '12 del mediodía';
    var s = h < 12 ? 'a. m.' : 'p. m.';
    h = h % 12 || 12;
    return h + ':' + (m < 10 ? '0' : '') + m + ' ' + s;
  }
  function antesDe(d) { return (d.getUTCHours() % 12 === 1 ? 'la ' : 'las ') + hora(d); }

  /* Horas y minutos, sin segundos: se lee como horario, no como cartel de feria. */
  function cuenta(seg) {
    if (seg < 60) return { texto: 'menos de 1 min', uno: true };
    var h = Math.floor(seg / 3600), m = Math.floor((seg % 3600) / 60);
    if (!h) return { texto: m + ' min', uno: m === 1 };
    if (!m) return { texto: h + ' h', uno: h === 1 };
    return { texto: h + ' h ' + m + ' min', uno: false };
  }

  /* «hoy» · «mañana miércoles 30» · «el viernes 2» (+ « de oct.») */
  function fecha(d, ahora, conMes) {
    var k = dias(ahora, d);
    var base = DIAS[d.getUTCDay()] + ' ' + d.getUTCDate() + (conMes ? ' de ' + MESES[d.getUTCMonth()] : '');
    if (k === 0) return 'hoy ' + base;
    if (k === 1) return 'mañana ' + base;
    return 'el ' + base;
  }

  function rango(r) {
    if (clave(r.desde) === clave(r.hasta)) {
      var k = dias(r.ahora, r.hasta);
      if (k === 0) return 'hoy mismo';
      return fecha(r.hasta, r.ahora, k > 6 || r.hasta.getUTCMonth() !== r.ahora.getUTCMonth());
    }
    var otroMes = r.desde.getUTCMonth() !== r.hasta.getUTCMonth();
    return 'entre ' + fecha(r.desde, r.ahora, otroMes) + ' y ' + fecha(r.hasta, r.ahora, true);
  }

  /* «p. m.» al final de una oración ya trae su punto: «…las 2:00 p. m.. Lo que» no (L-2). */
  function pon(plantilla, datos) {
    return String(plantilla || '').replace(/\{(\w+)\}/g, function (todo, k) {
      return datos[k] === undefined ? todo : datos[k];
    }).replace(/([^.])\.\.(?!\.)/g, '$1.');
  }

  var TEXTOS = {
    titular: 'Llega gratis {fecha}',
    antes: 'Pídelo antes de {hora} y sale hoy.',
    despues: '',
    faltan: 'Faltan {cuenta}',
    falta: 'Falta {cuenta}'
  };

  /* Lo que se pinta. `{fecha}` va marcada para que la hoja la ponga en su color. */
  function decir(r, textos) {
    var t = textos || TEXTOS, c = cuenta(r.resta);
    return {
      titular: pon(t.titular, { fecha: '<b>' + rango(r) + '</b>' }),
      frase: r.saleHoy
        ? pon(t.antes, { hora: antesDe(r.corte) })
        : pon(t.despues, { sale: '<b>' + fecha(r.sale, r.ahora, dias(r.ahora, r.sale) > 6) + '</b>' }),
      pastilla: r.saleHoy ? pon(c.uno ? t.falta : t.faltan, { cuenta: c.texto }) : '',
      /* la misma cuenta, con la cifra marcada: la forma suelta la pone en tinta */
      cuenta: r.saleHoy ? pon(c.uno ? t.falta : t.faltan, { cuenta: '<b>' + c.texto + '</b>' }) : ''
    };
  }

  /* ---------- el montaje ---------- */
  var RELOJ = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>';

  /* Espacios duros: el número se queda con su mes («30 de sep.»), la hora con su «p. m.». El
     nombre del día sí puede quedarse al final del renglón: así la fecha usa todo el ancho. */
  function duro(s) {
    var u = ' ';
    return String(s)
      .replace(/(\d+) de (\S+)/g, '$1' + u + 'de' + u + '$2')
      .replace(/(\d+:\d+) ([ap])\. m\./g, '$1' + u + '$2.' + u + 'm.')
      .replace(/12 del mediodía/g, '12' + u + 'del' + u + 'mediodía')
      .replace(/hoy mismo/g, 'hoy' + u + 'mismo');
  }

  /* La copia de lo último escrito va en `data-aud-html`, no en `data-dice`: ese nombre es el
     selector del titular, y con la frase antes en el DOM la primera pintada se la comía (L-1). */
  function escribe(nodo, html) {
    if (nodo && nodo.dataset.audHtml !== html) { nodo.innerHTML = html; nodo.dataset.audHtml = html; }
  }

  /* LA FRASE Y LA CUENTA, EN UN RENGLÓN (forma suelta). A la frase se le quita su punto final y
     a la cuenta su mayúscula: «Pídelo antes de las 2:00 p. m. y sale hoy · faltan 3 h 40 min».
     El punto de «p. m.» es de la abreviatura y se queda. */
  function sinPunto(s) { return /[ap]\. m\.$/.test(s) ? s : s.replace(/\.$/, ''); }
  function minuscula(s) { return s.charAt(0) === '<' ? s : s.charAt(0).toLowerCase() + s.slice(1); }

  /* Arma la pieza UNA vez y después solo cambia lo que cambió (lección L-8 del carrito:
     repintar entero cada segundo da saltos de scroll y corta las animaciones).
     TARJETA (el cajón): la cuenta va primero, en pastilla; luego la frase que la explica y la
     fecha. SUELTA (la ficha, D-078): la fecha con su ícono y debajo la frase con la cuenta.
     Pasado el corte, en las dos, solo la fecha. `op.icono` es el dibujo ya pintado por Liquid. */
  function montar(el, op) {
    op = op || {};
    var t = op.textos || TEXTOS, suelta = op.forma === 'suelta';
    el.classList.add('aud-entrega');
    el.classList.toggle('aud-entrega--cajon', !!op.cajon);
    el.classList.toggle('aud-entrega--suelta', suelta);
    el.setAttribute('data-mov', suelta ? 'ninguno' : op.mov || 'onda');
    el.innerHTML = suelta
      ? '<div class="aud-entrega__suelta">' +
          '<p class="aud-entrega__fecha">' +
            (op.icono ? '<span class="aud-entrega__icono" aria-hidden="true">' + op.icono + '</span>' : '') +
            '<span data-dice aria-live="polite"></span>' +
          '</p>' +
          '<p class="aud-entrega__renglon" data-pie hidden>' +
            '<span data-frase></span>' +
            '<span class="aud-entrega__punto" data-punto aria-hidden="true"> · </span>' +
            '<span class="aud-entrega__cuenta" data-cuenta></span>' +
          '</p>' +
        '</div>'
      : '<div class="aud-entrega__tarjeta">' +
          '<div class="aud-entrega__pie" data-pie hidden>' +
            '<span class="aud-entrega__pastilla" data-pastilla hidden>' + RELOJ + '<span data-cuenta></span></span>' +
            '<p class="aud-entrega__frase" data-frase></p>' +
          '</div>' +
          '<p class="aud-entrega__dice" data-dice aria-live="polite"></p>' +
        '</div>';

    /* La cuenta más ancha de un día cualquiera. Con ella se decide si la frase y la cuenta caben
       en un renglón: así «faltan 3 h» y «faltan 2 h 59 min» quedan en el mismo sitio, y el botón
       de pedir no sube ni baja bajo el dedo cada vez que cambia el minuto. */
    var medido = '', ultimo = null, reserva = pon(t.faltan, { cuenta: '<b>23 h 59 min</b>' });

    function pinta(instante) {
      var r = calcular(instante, op.zona || 'pais', op.reglas), d = decir(r, t);
      var pie = el.querySelector('[data-pie]'), c = el.querySelector('[data-cuenta]');
      ultimo = instante;
      escribe(el.querySelector('[data-dice]'), duro(d.titular));

      if (!suelta) {
        escribe(el.querySelector('[data-frase]'), duro(d.frase));
        if (c.textContent !== d.pastilla) c.textContent = d.pastilla;
        el.querySelector('[data-pastilla]').hidden = !d.pastilla;
        pie.hidden = !d.frase && !d.pastilla;
        return r;
      }

      var junta = !!(d.frase && d.cuenta), frase = el.querySelector('[data-frase]');
      escribe(frase, duro(junta ? sinPunto(d.frase) : d.frase));
      el.querySelector('[data-punto]').hidden = !junta;
      pie.hidden = !d.frase && !d.cuenta;

      /* ¿CABEN LA FRASE Y LA CUENTA EN UN RENGLÓN? Se mide, no se supone un ancho: el texto es
         del editor. Primero con la cuenta de reserva y después con la de verdad (que solo es más
         ancha en el último minuto, «menos de 1 min»). Si alguna cae al renglón de abajo, la
         cuenta baja ENTERA: renglón propio, con su mayúscula y sin el punto medio. Solo se vuelve
         a medir cuando cambia el texto o el ancho. */
      var clave = d.frase + '|' + d.cuenta + '|' + el.clientWidth;
      if (clave !== medido) {
        medido = clave;
        pie.classList.remove('is-partida');
        var cae = function (html) {
          escribe(c, minuscula(html));
          var a = frase.getClientRects(), b = c.getClientRects();
          return !!(a.length && b.length && b[0].top > a[a.length - 1].top + 2);
        };
        if (junta && (cae(reserva) || cae(d.cuenta))) pie.classList.add('is-partida');
        if (!junta || pie.classList.contains('is-partida')) escribe(c, d.cuenta);
      }
      return r;
    }

    /* La letra del tema puede llegar después de la primera pintada, y con ella cambia lo que cabe. */
    var doc = raiz.document;
    if (suelta && doc && doc.fonts && doc.fonts.ready) {
      doc.fonts.ready.then(function () { medido = ''; if (ultimo !== null && el.isConnected) pinta(ultimo); });
    }
    return { pinta: pinta };
  }

  /* Las reglas y los textos, de la sección «Fecha de entrega». Sin ella, no hay tarjeta. */
  var datos;
  function leerDatos() {
    if (datos !== undefined) return datos;
    datos = null;
    try {
      var caja = raiz.document && raiz.document.getElementById('aud-entrega-datos');
      if (caja) datos = JSON.parse(caja.textContent);
    } catch (e) { datos = null; }
    return datos;
  }

  var api = {
    REGLAS: REGLAS, TEXTOS: TEXTOS, calcular: calcular, decir: decir, festivosDe: festivosDe,
    festivo: festivo, enBogota: enBogota, clave: clave, dias: dias, hora: hora, cuenta: cuenta,
    fecha: fecha, rango: rango, DIAS: DIAS, montar: montar, duro: duro, leerDatos: leerDatos
  };
  if (typeof module !== 'undefined' && module.exports) { module.exports = api; return; }
  raiz.AudEntrega = api;

  /* ---------- <aud-entrega>, en la ficha ----------
     Lleva `data-skip-node-update`: cuando Horizon vuelve a pintar la sección al cambiar de talla,
     el morph deja este nodo en paz. Por si acaso, al reconectarse comprueba que la pieza
     siga dentro y la vuelve a armar si no. La forma viene en `data-forma` y el ícono, ya
     pintado por Liquid, en un <template>: se recoge antes de armar, porque armar lo borra. */
  if (!raiz.customElements || raiz.customElements.get('aud-entrega')) return;
  var Entrega = function () { return Reflect.construct(HTMLElement, [], Entrega); };
  Entrega.prototype = Object.create(HTMLElement.prototype, {
    connectedCallback: { value: function () {
      var d = leerDatos();
      if (!d) return;
      var el = this;
      if (!el._pieza || !el.querySelector('[data-dice]')) {
        var molde = el.querySelector('template');
        if (molde) el._icono = molde.innerHTML.trim();
        el._pieza = montar(el, {
          textos: d.textos, reglas: d.reglas, mov: d.mov,
          forma: el.getAttribute('data-forma') || 'tarjeta', icono: el._icono || ''
        });
      }
      el._pinta = function () { if (!raiz.document.hidden) el._pieza.pinta(Date.now()); };
      el._pinta();
      el._tic = setInterval(el._pinta, 1000);
      raiz.document.addEventListener('visibilitychange', el._pinta);
    } },
    disconnectedCallback: { value: function () {
      clearInterval(this._tic);
      raiz.document.removeEventListener('visibilitychange', this._pinta);
    } }
  });
  Object.setPrototypeOf(Entrega, HTMLElement);
  raiz.customElements.define('aud-entrega', Entrega);
})(typeof window !== 'undefined' ? window : this);
